// ** Initial State
const initialState = {
    categories: [],
    subCategories: []
}

const othersReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_CATEGORIES':
            return {
                ...state,
                categories: action.data
            }
        case 'GET_SUBCATEGORIES':
            return {
                ...state,
                subCategories: action.data
            }
        default:
            return state
    }
}

export default othersReducer
